import React, { useId } from 'react';
import { EditorContent } from '@tiptap/react';

import { useRichTextEditor } from '@producer/ui-kit';
import { EditorBubbleMenu } from '../rich-editor/editor-bubble-menu';

import styles from './editor.module.scss';

interface EditorProps {
  /**
   * Set the initial content for the editor
   */
  content?: string;

  onChange: (value: string) => void;

  placeholder?: string;
}

export const Editor: React.FC<EditorProps> = ({
  content = '',
  onChange,
  placeholder = 'Write your notes here...',
}) => {
  const id = useId();

  const { editor, isTextSelected } = useRichTextEditor({
    key: id,
    value: content,
    placeholder,
    onBlur: onChange,
  });

  return (
    <div className={styles.container} onClick={() => editor.commands.focus()}>
      {editor && isTextSelected && <EditorBubbleMenu editor={editor} />}
      <EditorContent className={styles.editor} editor={editor} />
    </div>
  );
};
